import { render, staticRenderFns } from "./BatchAddSubscriptionForm.vue?vue&type=template&id=ffb909d8&scoped=true&"
import script from "./BatchAddSubscriptionForm.vue?vue&type=script&lang=js&"
export * from "./BatchAddSubscriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./BatchAddSubscriptionForm.vue?vue&type=style&index=0&id=ffb909d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb909d8",
  null
  
)

export default component.exports